// DS8.1 (!) comes with consts:
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import c from 'classnames';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ModalRoot, ModalCloseButton } from '../../base';
import ModalLayout from './ModalLayout';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import s from './Modal.scss';
export const MODAL_FOOTER_BUTTON_SIZE = 'large';
export const MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH = 100;
/** Our Standard modal. Has a heading, subheading, close button, and footer.  */ const Modal = (_param)=>{
    var { isOpen, heading, subheading, headerLeft, headerRight, headerClassName, preamble, footerLeft, footerRight, footer, footerPadding, showHeaderBorder, showFooterBorder, children, className, contentClassName, innerScrollRef, withScrollableContentWrapper = true, isFullscreen: isFullscreenProp, alwaysLight = false, layoutClassName, ignoreClickOutside, ipadMode = false } = _param, rest = _object_without_properties(_param, [
        "isOpen",
        "heading",
        "subheading",
        "headerLeft",
        "headerRight",
        "headerClassName",
        "preamble",
        "footerLeft",
        "footerRight",
        "footer",
        "footerPadding",
        "showHeaderBorder",
        "showFooterBorder",
        "children",
        "className",
        "contentClassName",
        "innerScrollRef",
        "withScrollableContentWrapper",
        "isFullscreen",
        "alwaysLight",
        "layoutClassName",
        "ignoreClickOutside",
        "ipadMode"
    ]);
    const isMobile = useContext(MobileContext);
    const enableIpad = ipadMode && typeof document !== 'undefined' && navigator.userAgent.includes('Mac') && 'ontouchend' in document;
    const isFullscreen = (isFullscreenProp !== null && isFullscreenProp !== void 0 ? isFullscreenProp : isMobile) || enableIpad;
    return /*#__PURE__*/ React.createElement(MobileContext.Provider, {
        value: isMobile || (enableIpad !== null && enableIpad !== void 0 ? enableIpad : false)
    }, /*#__PURE__*/ React.createElement(ModalRoot, _object_spread({
        ipadMode: ipadMode,
        isOpen: isOpen,
        className: c(className, ignoreClickOutside && 'ignore-react-onclickoutside'),
        // We'll define it manually so that it respects the ThemeOverride
        hasCloseButton: false,
        isFullscreen: isFullscreen
    }, rest), /*#__PURE__*/ React.createElement(ThemeOverride, {
        className: s['theme-wrapper'],
        theme: alwaysLight ? ThemeOptions.LIGHT : undefined
    }, /*#__PURE__*/ React.createElement(ModalLayout, {
        className: layoutClassName,
        isFullscreen: isFullscreen,
        withScrollableContentWrapper: withScrollableContentWrapper,
        innerScrollRef: innerScrollRef,
        header: heading && /*#__PURE__*/ React.createElement(ModalHeader, {
            className: headerClassName,
            heading: heading,
            subheading: subheading,
            left: headerLeft,
            right: headerRight
        }),
        preamble: preamble,
        content: children,
        contentClassName: contentClassName,
        footer: footer || (!!footerLeft || !!footerRight) && /*#__PURE__*/ React.createElement(ModalFooter, {
            left: footerLeft,
            right: footerRight
        }),
        footerPadding: footerPadding,
        headerBorder: showHeaderBorder,
        footerBorder: showFooterBorder
    }), /*#__PURE__*/ React.createElement(ModalCloseButton, {
        className: s['close-button']
    }))));
};
Modal.displayName = 'Modal';
export default Modal;

//# sourceMappingURL=Modal.js.map